import mustache from 'mustache';

import { getAllFeatureFlags } from "../util/general_util";
import { Trip_ReqFields_stopByStop } from "../util/type_defs";
import { send_AIsearchAllInOne, send_tripPlanAllInOneSearch, stopByStop_search } from "./api_utils";
import { set_tripFilters } from "./trip_utils";
import { addSearchErrorFeedback_tripPlanner, hide_map_loadingIcon, hide_map_loadingIcon_genieJourneySearch, show_map_loadingIcon, show_map_loadingIcon_genieJourneySearch } from "./ui_utils";
import { stopByStop_newStopTemplate } from '../util/mustache_templates';
import { display_trip } from './tripPlanner_scripts';
import { send_getAPItoken } from '../util/search_api';
import { reset_interaction_counter } from './util/helper_functions';

const stopByStop_newStop:JQuery<HTMLElement> = $(mustache.render(stopByStop_newStopTemplate,{}));


export const build_trip_from_query_args = async (stops_strings:string[]) => {
	for (let i:number = 0; i < stops_strings.length; i++) {
		let stop_components:string[] = stops_strings[i].split(",");
		let query_type:string|null = null;
		let query_val:string|null = null;
		let text:string|null=null;
		switch(stop_components.length) {
			case 1:
				text = decodeURIComponent(stop_components[0]);
				break;
			case 3:
				query_type = stop_components[0];
				query_val = decodeURIComponent(stop_components[1]);
				text = decodeURIComponent(stop_components[2]);
				break;
			default:
				break;
		};
		if (text == null) continue;

		if (i == 0) {
			$("#startLocation").val(text);
			if (query_type != null && query_val != null) {
				$("#startLocation").attr("query_type",query_type);
				$("#startLocation").attr("query_val",query_val);
			};
		} else if (i == 1) {
			$("#firstStopLocation").val(text);
			if (query_type != null && query_val != null) {
				$("#firstStopLocation").attr("query_type",query_type);
				$("#firstStopLocation").attr("query_val",query_val);
			};
		} else {
			let addedInput:boolean = await stopByStop_addStopInput(null);
			if (addedInput) {
				let newEl:HTMLElement = $(".stop-by-stop-input")[$(".stop-by-stop-input").length -1];

				$(newEl).val(text);
				if (query_type != null && query_val != null) {
					$(newEl).attr("query_type",query_type);
					$(newEl).attr("query_val",query_val);
				};
			};
		};
	};
};

export async function stopByStop_addStopInput(event:JQuery.ClickEvent):Promise<boolean> {
	if (window.featureFlags == undefined) {
		await getAllFeatureFlags();
	};
	let subLevel:string;
    let popupId:string|null;
    switch(parseInt(window.GAsubLevel)) {
        case 2:
            subLevel = "subscriber";
            popupId = null;
            break;
        case 1:
            subLevel = "subscriber";
            popupId = null;
            break;
        case 0:
            subLevel = "member";
			if(window.featureFlags.freeTrialState == "carded"){
				popupId = "#freemium-carded-trial"
			}else{
				popupId = "#freemium-subscribe"
			}
            break;
        default:
            subLevel = "anonymous";
            popupId = "#signupModal"
            break;
    }

    if (parseInt(window.GAsubLevel) < 1 || window.GAsubLevel == null) {
        if ($(".stop-by-stop-input").length >= window.featureFlags.freemiumAccess.addStops[subLevel]) {
            let msg:string = "To add another stop, purchase AdventureGenie Pro!";
            $(popupId).find("[signUpMsg]").html(msg);
            $(popupId).modal("show");
            return false;
        };
    };

	let $newStop:JQuery<HTMLElement> = $(stopByStop_newStop).clone();

	$newStop.find("i.ai-trash").on("click", ()=>{$newStop.remove()})

	$("#stopByStop_searchSidebar").find("#stopByStop_addStop").parent().before($($newStop));

	return true;
};

export function submitSearch_StopByStopTrip(event: JQuery.SubmitEvent) {
	event.preventDefault();

	let requestParams: Trip_ReqFields_stopByStop;
	let allInput_queries: Array<string> | null;
	let inputForm: HTMLFormElement = $("#stopByStop_submitSearch")[0] as HTMLFormElement;
	let firstEmptyInput: HTMLElement | null = null;

	let autofillData: Array<{ query_type: string | null, query_val: string | null }> = [];

	$(".stop-by-stop-input").each(function (this) {
		if (this instanceof HTMLInputElement) {
			this.setCustomValidity("");
		};
	});

	allInput_queries = [];
	$(".stop-by-stop-input").each(function (this) {
		let val: string = ($(this).val() as string).trim();

		let query_type: string | null = $(this).attr("query_type");
		let query_val: string | null = $(this).attr("query_val");

		if (query_type != undefined && query_val != undefined) {
			autofillData.push({ query_type: query_type, query_val: query_val });
		} else {
			autofillData.push({ query_type: null, query_val: null });
		};

		if (val == null || val == undefined || (typeof val == "string" && val.length == 0)) {
			if (firstEmptyInput === null) firstEmptyInput = this;
			return;
		};
		allInput_queries.push(val.toString());
	});
	if (allInput_queries.length < 2) {
		if (firstEmptyInput instanceof HTMLInputElement) {
			firstEmptyInput.setCustomValidity("Need At Least 2 Stops");
			inputForm.reportValidity();
			return;
		};
	};
	inputForm.reportValidity();
	set_tripFilters(window.tripPlannerCurrentTrip, $("#stopByStop_submitSearch"));
	requestParams = {
		"filters": window.tripPlannerCurrentTrip.filters,
		"autofillData": autofillData,
		"stopQueries": allInput_queries
	};

	const avoidAreas = $("#avoid-area-entries_preSearch").find("[avoid-area-entry-wrap]");
	avoidAreas.each(function(i,el) {
		const id = $(el).attr("id");
		const query = $(el).find("[avoid-area-name]").html();
		const newAvoidArea:{id:string,name:string,bounds:null} = {
			id: id,
			name: query,
			bounds: null
		};
		if (window.tripPlannerCurrentTrip.filters.avoidAreas) {
			window.tripPlannerCurrentTrip.filters.avoidAreas.push(newAvoidArea);
		} else {
			window.tripPlannerCurrentTrip.filters.avoidAreas = [newAvoidArea];
		};
	});

	show_map_loadingIcon("Creating your trip!");
	$("#tripSearchModal").hide();

	stopByStop_search(requestParams).then(trip => {
		window.tripPlannerCurrentTrip = trip;
        hide_map_loadingIcon();
		$("#tripSearchModal").remove();

		display_trip(trip, true);

		reset_interaction_counter();

	}).catch(e => {
		hide_map_loadingIcon();
		$("#tripSearchModal").show();
		let errJson = JSON.parse(e.message);
		$("#stopByStop_searchSidebar").collapse("show");
		$(".stop-by-stop-input").filter(function() {
			return $(this).val() === errJson.query;
		}).each(function() {
			addSearchErrorFeedback_tripPlanner($(this), errJson.msg, false);
		});
	});
};

export async function genieJourneySearch(event:JQuery.SubmitEvent) {
	event.preventDefault();

	const query: string = $("#allInOneSearch").val() as string;
	const apiToken: string = await send_getAPItoken();

	$("#allInOneSearch_postQueryDisp").html(`"${query}"`);
	$("#genieTripLoading").show();
	// show_map_loadingIcon("Creating your trip!");
	show_map_loadingIcon_genieJourneySearch();
    $("#tripSearchModal").hide();

	send_AIsearchAllInOne(apiToken, query).then(stopData => {
		send_tripPlanAllInOneSearch(stopData,query).then(trip => {
			window.tripPlannerCurrentTrip = trip;
			// hide_map_loadingIcon();
			hide_map_loadingIcon_genieJourneySearch();
			$("#tripSearchModal").remove();

			$("#genieTripLoading").remove();

			display_trip(trip, true);

			if (trip.failed_auto_add_camps == true) {
				const errToastHTML = [
					'<div class="toast show bottom-0 end-0 me-2 mb-2 position-absolute" style="z-index:10000" role="alert" aria-live="assertive" aria-atomic="true" data-bs-autohide="false">',
						'<div class="toast-header bg-primary text-white">',
							'<i class="ai-bell fs-lg me-2"></i>',
							'<span class="fw-medium me-auto">{{ title_msg }}</span>',
							'<button type="button" class="btn-close btn-close-white ms-2" data-bs-dismiss="toast" aria-label="Close"></button>',
						'</div>',
						'<div class="toast-body text-primary">{{ sub_msg }}</div>',
					'</div>'
				].join("\n")
				const errToast = $(mustache.render(errToastHTML, {title_msg:"We were unable to automatically add campgrounds to all your stops.",sub_msg:"Please make sure you are signed in with the Pro Plan & have set your preferences in settings"}));
				$(document.body).append(errToast);
			};
			reset_interaction_counter();
		}).catch(e => {
			console.error(e);
			addSearchErrorFeedback_tripPlanner($("#allInOneSearch"), "Hmmm, that didn't work. Try making your request less specific.",true);
			hide_map_loadingIcon_genieJourneySearch();
			$("#tripSearchModal").show();
			$("#genieTripLoading").hide();
		})
	}).catch(e => {
		console.error(e);
		// hide_map_loadingIcon();
		addSearchErrorFeedback_tripPlanner($("#allInOneSearch"), "Hmmm, that didn't work. Try making your request less specific.",true);
		hide_map_loadingIcon_genieJourneySearch();
		$("#tripSearchModal").show();
		$("#genieTripLoading").hide();
	})
};